import LocalizedStrings from "react-localization";
import _en from "./en.json";
import _de from "./de.json";
import _tr from "./tr.json";

export default class Consts {
  static TEST = false;
  static primerect_locale_seted = false;
  static NEW_LINE = "\n";
  static filterDelay = 2000;
  static defaultRowsCountDataTable = 20;
  static localizedStrings = new LocalizedStrings({
    tr: {
      ..._tr,
    },
    en: {
      ..._en,
    },
    de: {
      ..._de,
    },
  });
  static network = {
    takip: {
      gorevler: {
        create: "/gorevler/create", //test ok
        update: "/gorevler/update", //test ok
        list: "/gorevler/list", //test ok
        delete: "/gorevler/delete", //test ok
      },
      gorev_list: {
        list: "/gorev_list/list",
      },
    },
    siparis_all_view: {
      get: "/siparis_all_view/get", //test ok
    },

    cari: {
      musteri_bilgileri: {
        list: "/cari/musteri-bilgileri/list",
      },
      cari_liste: {
        list: "/cari/cari-liste/list",
      },
    },
    stok: {
      get: "/stok/get", //test ok
      list: "/stok/list", //test ok
      create: "/stok/create", //test ok
      update: "/stok/update", //test ok
      delete: "/stok/delete", //test ok
      sendmail: "/stok/sendmail", //test ok
    },
    stok_hareketleri: {
      list: "/stok_hareketleri/list", //test ok
    },
    stok_islem: {
      list: "/stok_islem/list", //test ok
      create: "/stok_islem/create", //test ok
    },
    customers: {
      list: "/customers/list", //test ok
      get: "/customers/get", //test ok
      get_with_address: "/customers/get_with_address", //test ok
      get_with_siparis_icerik: "/customers/get_with_siparis_icerik", 
      create: "/customers/create", //test ok
      update: "/customers/update", //test ok
      delete: "/customers/delete", //test ok
      customers_by_dnd_report: "/customers/customers_by_dnd_report",
      customers_by_user_report: "/customers/customers_by_user_report",
      musteri_aktar: "/customers/musteri_aktar",
      import_file: "/customers/import_file",
      cus_note_base64: "/customers/cus_note_base64",
    },
    customer_all_list: {
      get: "/customer_all_list/get",
      list: "/customer_all_list/list",
      dogum_gunu_olan_musteriler: "/customer_all_list/dogum_gunu_olan_musteriler",
      cikrilmis_musterilerim: "/customer_all_list/cikrilmis_musterilerim",
    },
    customer_random_view: {
      list: "/customer_random_view/list",
    },
    sys_stok_color: {
      list: "/sys_stok_color/list", //test ok
    },
    sys_stok_mensey: {
      list: "/sys_stok_mensey/list", //test ok
    },
    sys_stok_sise: {
      list: "/sys_stok_sise/list", //test ok
    },
    sys_stok_tipi: {
      list: "/sys_stok_tipi/list", //test ok
    },
    // unvan: {
    //   list: "/sys_unvan/list",//test ok
    // },

    sys_category: {
      list: "/sys_category/list", //test ok
      create: "/sys_category/create", //test ok
      update: "/sys_category/update", //test ok
      delete: "/sys_category/delete", //
    },
    sys_country_code: {
      update: "/sys_country_code/update", //test ok
      list: "/sys_country_code/list", //test ok
    },
    prim_listesi: {
      acik_odemeleri_ozet: "/prim_listesi/acik_odemeleri_ozet",
      prim_listesi_getir: "/prim_listesi/prim_listesi_getir",
      toplamlar: "/prim_listesi/toplamlar",
    },
    sys_unvan: {
      list: "/sys_unvan/list", //test ok
    },
    sys_refdata: {
      list: "/sys_refdata/list", //test ok
    },
    firma_bilgileri: {
      get: "/firma-bilgileri/get", //test ok
      update: "/firma-bilgileri/update", //test ok
    },
    stok_all_list_view: {
      list_with_rest: "/stok_all_list_view/list_with_rest",
      list: "/stok_all_list_view/list", //test ok
      get: "/stok_all_list_view/get", //test ok
    },
    stok_all_list_view_aktif: {
      list: "/stok_all_list_view_aktif/list"
    },
    stok_urun_listesi_view: {
      list: "/stok_urun_listesi_view/list",
    },
    stok_search_dialialog_view: {
      list: "/stok_search_dialialog_view/list",
    },
    rezerve_stok_sip: {
      gonderilecek_saraplar: "/stok-rezerve-sip/gonderilecek-saparlar",
      list: "/stok_rezerve_sip/list",
    },
    stok_hareket_tip: {
      list: "/stok_hareket_tip/list",
    },
    siparis_firmalar: {
      list: "/siparis_firmalar/list",
    },
    stok_rezerve: {
      list: "/stok_rezerve/list",
    },
    stok_islem_tip: {
      list: "/stok_islem_tip/list",
    },
    siparisler: {
      list: "/siparisler/list",
      prim_list: "/siparisler/prim_list",
      list_bekleyen: "/siparisler/list-bekleyen",
      get: "/siparisler/get",
      get_siparis_with_icerik: "/siparisler/get_siparis_with_icerik",
      delete: "/siparisler/delete",
      on_islemi_onayla: "/siparisler/on_islemi_onayla",
      on_islemi_iptal: "/siparisler/on_islemi_iptal",
      count_sum: "/siparisler/count_sum",
      update: "/siparisler/update",
      fatura_iptali: "/siparisler/fatura_iptali",
      siparis_iptali: "/siparisler/siparis_iptali",
      siparis_onayla: "/siparisler/siparis_onayla",
      faturalandir_ve_rapor_data: "/siparisler/faturalandir_ve_rapor_data",
      fatura_siparis_kapat: "/siparisler/fatura_siparis_kapat",
      iptal_fatura_geri_al: "/siparisler/iptal_fatura_geri_al",
      fatura_acik_yap: "/siparisler/fatura_acik_yap",
      update_with_icerik: "/siparisler/update_with_icerik",
      create_with_icerik: "/siparisler/create_with_icerik",
      personel_ciro_report: "/siparisler/personel_ciro_report",
      personel_bazinda_bayi_satis_report: "/siparisler/personel_bazinda_bayi_satis_report",
      siparis_durumlari_report: "/siparisler/siparis_durumlari_report",
      personel_satislari_report: "/siparisler/personel_satislari_report",
      musteri_gecmis_siparis: "/siparisler/musteri_gecmis_siparis",
      son_siparis: "/siparisler/son_siparis",
      dashboard_report: "/siparisler/dashboard_report",
      siparis_report_data: "/siparisler/siparis_report_data",
    },
    kargo_cikti: {
      list: "/kargo_cikti/list",
      gonderilmis: "/kargo-cikti/list",
      teslim_edilmis: "/kargo-cikti/list",
    },
    siparis_icerik: {
      list: "/siparis_icerik/list",
    },
    kargo_sirketi: {
      list: "/kargo_sirketi/list",
    },

    kargo_islem: {
      gonderi_kaydet_ekle: "/kargo_islem/gonderi_kaydet_ekle",
      get: "/kargo_islem/get",
      save: "/kargo_islem/kayit_guncelle",
      update: "/kargo_islem/update",
    },
    sys_users: {
      list: "/sys_users/list",
      login: "/sys_users/login",
      logout: "/sys_users/logout",
      token: "/sys_users/token",
      update: "/sys_users/update",
      create: "/sys_users/create",
      delete: "/sys_users/delete",
      reset_password: "/sys_users/reset_password",
      sent_reset_password_link: "/sys_users/sent_reset_password_link",
      check_secret_input: "/sys_users/check_secret_input",
    },
    cari_islem_view: "/cari_islem_view",
    user_all_list_view: "/user_all_list_view",
    sys_siparis_durum: {
      list: "/sys_siparis_durum/list",
    },
    cus_dnd: {
      list: "/cus_dnd/list",
    },
    sys_c_time: {
      list: "/sys_c_time/list",
    },
    sys_class: {
      list: "/sys_class/list",
    },
    adres_list_view: {
      list: "/adres_list_view/list",
    },
    cari_islem: {
      list: "/cari_islem/list",
      odeme: "/cari_islem/odeme",
      delete: "/cari_islem/delete",
    },
    cus_adress: {
      get: "/cus_adress/get", //test ok
      update: "/cus_adress/update", //test ok
      create: "/cus_adress/create", //test ok
      delete: "/cus_adress/delete", //test ok
    },
    raking_figure: {
      list: "/raking_figure/list", //test ok
      update: "/raking_figure/update", //test ok
      create: "/raking_figure/create", //test ok
      delete: "/raking_figure/delete", //test ok
      random: "/raking_figure/random", //test ok
    },
    sys_adres_type: {
      list: "/sys_adres_type/list",
    },
    odeme_tipleri: {
      list: "/odeme_tipleri/list",
    },
    customer_rand_view: {
      list: "/customer_rand_view/list",
    },
    cus_taksitler: {
      list: "/cus_taksitler/list",
    },
    sys_fat_iptal: {
      list: "/sys_fat_iptal/list",
    },
    sys_fat_haciz: {
      list: "/sys_fat_haciz/list",
    },
    sys_gorusme_asama: {
      list: "/sys_gorusme_asama/list",
    },
    cus_files: {
      create: "/cus_files/create",
      update: "/cus_files/update",
      delete: "/cus_files/delete",
      list: "/cus_files/list",
      get: "/cus_files/get",
    },
    konusma_metin: {
      create: "/konusma_metin/create",
      update: "/konusma_metin/update",
      delete: "/konusma_metin/delete",
      list: "/konusma_metin/list",
      get: "/konusma_metin/get",
    },
    personel_odeme: {
      create: "/personel_odeme/create",
      list: "/personel_odeme/list",
      kdv_list: "/personel_odeme/kdv_list",
    },
    bayi_cari: {
      create: "/bayi_cari/create",
      update: "/bayi_cari/update",
      delete: "/bayi_cari/delete",
      list: "/bayi_cari/list",
    },
    sys_user_level: {
      list: "/sys_user_level/list",
    },
    musteri_gorusme: {
      create: "/musteri_gorusme/create",
      update: "/musteri_gorusme/update",
      delete: "/musteri_gorusme/delete",
    },
    prim_odeme_fis: {
      list: "/prim_odeme_fis/list",
      create: "/prim_odeme_fis/create",
      delete: "/prim_odeme_fis/delete",
      odeme_yap: "/prim_odeme_fis/odeme_yap",
    },
    musteri_gorusme_view: {
      list: "/musteri_gorusme_view/list",
      gorusme_detalari_report: "/musteri_gorusme_view/gorusme_detalari_report",
    },
    siparis_icerik_karsilastir: {
      stok_satislari: "/siparis_icerik_karsilastir/stok_satislari",
      stok_satis_rapor: "/siparis_icerik_karsilastir/stok_satis_rapor",
    },
    prim_odeme_fis_bayi: {
      list: "/prim_odeme_fis_bayi/list",
      update: "/prim_odeme_fis_bayi/update",
    },
    prim_odeme_fis_personel: {
      list: "/prim_odeme_fis_personel/list",
      update: "/prim_odeme_fis_personel/update",
    },
  };
  static status = {
    succes: {
      message: "İşlem Başarılı",
      detail: "",
      code: 1,
      isContinue: true,
    },
    waiting: {
      message: "İşlem Beklemede",
      code: 3,
      detail: "",
      isContinue: false,
    },
    fail: {
      message: "İşlem Başarısız",
      code: 0,
      detail: "",
      isContinue: false,
    },
  };

  static KEYS = {
    year: "year",
    color: "color",
    mensey: "mensey",
    sise: "sise",
    unvan: "unvan",
    ulke: "sys_country_code",
    stok_hareket_tip: "stok_hareket_tip",
    siparis_firmalar: "siparis_firmalar",
    stok_islem_tip: "stok_islem_tip",
    kargo_sirketi: "kargo_sirketi",
    sys_users: "sys_users",
    sys_siparis_durum: "sys_siparis_durum",
    cus_dnd: "cus_dnd",
    sys_c_time: "sys_c_time",
    sys_class: "sys_class",
    sys_category: "sys_category",
    sys_adres_type: "sys_adres_type",
    odeme_tipleri: "odeme_tipleri",
    sys_fat_iptal: "sys_fat_iptal",
    sys_fat_haciz: "sys_fat_haciz",
    sys_gorusme_asama: "sys_gorusme_asama",
    bayi_cari: "bayi_cari",
    sesion_id: "sesion_id",
    firma_bilgileri: "firma_bilgileri",
    sys_user_level:"sys_user_level",
    stok_tipi:"stok_tipi",
    FilterMatchMode: {
      STARTS_WITH: "startsWith",
      CONTAINS: "contains",
      NOT_CONTAINS: "notContains",
      ENDS_WITH: "endsWith",
      EQUALS: "equals",
      NOT_EQUALS: "notEquals",
      IN: "in",
      LESS_THAN: "lt",
      LESS_THAN_OR_EQUAL_TO: "lte",
      GREATER_THAN: "gt",
      GREATER_THAN_OR_EQUAL_TO: "gte",
      BETWEEN: "between",
      DATE_IS: "dateIs",
      DATE_IS_NOT: "dateIsNot",
      DATE_BEFORE: "dateBefore",
      DATE_BEFORE_EQ: "dateBeforeEq",
      DATE_AFTER: "dateAfter",
      DATE_AFTER_EQ: "dateAfterEq",
      TIME_IS: "timeIs",
      TIME_IS_NOT: "timeIsNot",
      TIME_BEFORE: "timeBefore",
      TIME_BEFORE_EQ: "timeBeforeEq",
      TIME_AFTER: "timeAfter",
      TIME_AFTER_EQ: "timeAfterEq",
      IS_NULL: "isNull",
      IS_NOT_NULL: "isNotNull",
    },
    FilterOperator: {
      AND: "and",
      OR: "or",
    },
  };
  static emptyImageBase64 =
    "data:image/jpeg;base64,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";
}
